export type Lang = 'en' | 'fr' | 'es'

export const translations: Record<string, Record<Lang, string>> = {
  // Hero
  'hero.title.part1': {
    en: 'Where Every Event',
    fr: 'Où Chaque Événement',
    es: 'Donde Cada Evento',
  },
  'hero.title.part2': {
    en: 'Deserves a Cheers!',
    fr: 'Mérite un Toast !',
    es: 'Merece un Brindis!',
  },
  'hero.subtitle': {
    en: 'Elevate your celebration with our premier mobile bartending service. We bring tropical elegance, custom cocktails, and unforgettable experiences directly to you.',
    fr: "Sublimez votre célébration avec notre service de barman mobile de premier choix. Nous vous apportons l'élégance tropicale, des cocktails sur mesure et des expériences inoubliables.",
    es: 'Eleva tu celebración con nuestro servicio de coctelería móvil de primer nivel. Llevamos la elegancia tropical, cócteles personalizados y experiencias inolvidables directamente a ti.',
  },
  'hero.cta': {
    en: 'Book Now',
    fr: 'Réserver',
    es: 'Reservar Ahora',
  },
  'hero.scroll': {
    en: 'Scroll',
    fr: 'Défiler',
    es: 'Desplazar',
  },

  // About
  'about.title.part1': {
    en: 'Crafting',
    fr: 'Créer des',
    es: 'Creando',
  },
  'about.title.part2': {
    en: 'Unforgettable',
    fr: 'Inoubliables',
    es: 'Inolvidables',
  },
  'about.title.part3': {
    en: 'Moments',
    fr: 'Moments',
    es: 'Momentos',
  },
  'about.p1.part1': {
    en: 'At',
    fr: 'Chez',
    es: 'En',
  },
  'about.p1.part2': {
    en: ", every event deserves a cheers. We believe that a great drink is more than just a beverage—it's an experience, a conversation starter, and a memory in the making.",
    fr: ", chaque événement mérite un toast. Nous croyons qu'un bon verre est plus qu'une simple boisson : c'est une expérience, un déclencheur de conversation et un souvenir en devenir.",
    es: ', cada evento merece un brindis. Creemos que una gran bebida es más que solo una bebida: es una experiencia, un iniciador de conversaciones y un recuerdo en proceso.',
  },
  'about.p2': {
    en: 'We craft unforgettable moments with great cocktails and signature packages where every pour is crafted to impress. From intimate gatherings to grand celebrations, we bring the perfect blend of professionalism, flair, and tropical elegance to your venue.',
    fr: "Nous créons des moments inoubliables avec d'excellents cocktails et des forfaits signature où chaque service est conçu pour impressionner. Des rassemblements intimes aux grandes célébrations, nous apportons le mélange parfait de professionnalisme, de style et d'élégance tropicale à votre lieu.",
    es: 'Creamos momentos inolvidables con excelentes cócteles y paquetes exclusivos donde cada servicio está diseñado para impresionar. Desde reuniones íntimas hasta grandes celebraciones, llevamos la combinación perfecta de profesionalismo, estilo y elegancia tropical a tu evento.',
  },

  // Signature Package
  'package.title.part1': {
    en: 'The',
    fr: 'Le Forfait',
    es: 'El Paquete',
  },
  'package.title.part2': {
    en: 'Signature',
    fr: 'Signature',
    es: 'Exclusivo',
  },
  'package.title.part3': {
    en: 'Package',
    fr: '',
    es: '',
  },
  'package.f1.title': {
    en: '4-Hour Bartending',
    fr: '4 Heures de Service',
    es: '4 Horas de Servicio',
  },
  'package.f1.desc': {
    en: 'Dedicated professional service for the duration of your main event.',
    fr: 'Service professionnel dédié pour la durée de votre événement principal.',
    es: 'Servicio profesional dedicado durante la duración de tu evento principal.',
  },
  'package.f2.title': {
    en: '2 Signature Cocktails',
    fr: '2 Cocktails Signature',
    es: '2 Cócteles Exclusivos',
  },
  'package.f2.desc': {
    en: 'Custom-crafted drinks designed specifically for your theme and taste.',
    fr: 'Boissons créées sur mesure, conçues spécifiquement pour votre thème et vos goûts.',
    es: 'Bebidas elaboradas a medida, diseñadas específicamente para tu temática y gustos.',
  },
  'package.f3.title': {
    en: 'Elevated Garnish Stadium',
    fr: 'Station de Garnitures Élégante',
    es: 'Estación de Guarniciones Elegante',
  },
  'package.f3.desc': {
    en: 'A visually stunning display of fresh, premium garnishes.',
    fr: 'Une présentation visuellement époustouflante de garnitures fraîches et de qualité.',
    es: 'Una exhibición visualmente impresionante de guarniciones frescas y de primera calidad.',
  },
  'package.f4.title': {
    en: 'Tropical Elegance',
    fr: 'Élégance Tropicale',
    es: 'Elegancia Tropical',
  },
  'package.f4.desc': {
    en: 'A styled setup that brings a warm, luxurious vibe to any space.',
    fr: 'Une installation stylisée qui apporte une ambiance chaleureuse et luxueuse à tout espace.',
    es: 'Un montaje estilizado que aporta un ambiente cálido y lujoso a cualquier espacio.',
  },

  // Why Mobile Bartender
  'why.title.part1': {
    en: 'Why You Need a',
    fr: 'Pourquoi Choisir un',
    es: 'Por Qué Necesitas un',
  },
  'why.title.part2': {
    en: 'Mobile Bartender',
    fr: 'Barman Mobile',
    es: 'Barman Móvil',
  },
  'why.subtitle': {
    en: 'A bartender elevates your entire event. Here is why choosing a professional makes all the difference.',
    fr: 'Un barman sublime tout votre événement. Voici pourquoi choisir un professionnel fait toute la différence.',
    es: 'Un barman eleva todo tu evento. Aquí te explicamos por qué elegir a un profesional marca la diferencia.',
  },
  'why.b1.title': {
    en: 'No Stress',
    fr: 'Sans Stress',
    es: 'Sin Estrés',
  },
  'why.b1.desc': {
    en: "You're not stuck making drinks all night — you actually get to enjoy your event.",
    fr: "Vous n'êtes pas coincé à préparer des verres toute la soirée — vous profitez vraiment de votre événement.",
    es: 'No estás atrapado preparando bebidas toda la noche — realmente puedes disfrutar de tu evento.',
  },
  'why.b2.title': {
    en: 'Professional & Fast',
    fr: 'Professionnel & Rapide',
    es: 'Profesional y Rápido',
  },
  'why.b2.desc': {
    en: 'No long lines, no messy pours — just smooth, high-quality cocktails all night.',
    fr: "Pas de longues files d'attente, pas de service brouillon — juste des cocktails fluides et de haute qualité toute la nuit.",
    es: 'Sin largas filas, sin derrames — solo cócteles fluidos y de alta calidad toda la noche.',
  },
  'why.b3.title': {
    en: 'Aesthetic Experience',
    fr: 'Expérience Esthétique',
    es: 'Experiencia Estética',
  },
  'why.b3.desc': {
    en: 'A styled bar setup instantly upgrades your event and creates that wow factor.',
    fr: 'Un bar stylisé rehausse instantanément votre événement et crée cet effet waouh.',
    es: 'Un montaje de bar estilizado mejora instantáneamente tu evento y crea ese factor sorpresa.',
  },
  'why.b4.title': {
    en: 'Custom Cocktails',
    fr: 'Cocktails Sur Mesure',
    es: 'Cócteles Personalizados',
  },
  'why.b4.desc': {
    en: 'Signature drinks made just for your theme — an unforgettable experience.',
    fr: 'Des boissons signature créées juste pour votre thème — une expérience inoubliable.',
    es: 'Bebidas exclusivas creadas solo para tu temática — una experiencia inolvidable.',
  },
  'why.b5.title': {
    en: 'Happy Guests, Better Party',
    fr: 'Invités Heureux, Meilleure Fête',
    es: 'Invitados Felices, Mejor Fiesta',
  },
  'why.b5.desc': {
    en: 'When drinks are flowing and service is smooth, the energy is just better.',
    fr: "Quand les verres s'enchaînent et que le service est fluide, l'énergie est tout simplement meilleure.",
    es: 'Cuando las bebidas fluyen y el servicio es fluido, la energía es simplemente mejor.',
  },
  'why.b6.title': {
    en: 'Luxury Without Stress',
    fr: 'Le Luxe Sans Stress',
    es: 'Lujo Sin Estrés',
  },
  'why.b6.desc': {
    en: 'You bring the party, we bring the experience.',
    fr: "Vous apportez la fête, nous apportons l'expérience.",
    es: 'Tú traes la fiesta, nosotros traemos la experiencia.',
  },

  // Additional Services
  'services.title.part1': {
    en: 'Beyond the',
    fr: 'Au-delà du',
    es: 'Más Allá del',
  },
  'services.title.part2': {
    en: 'Bar',
    fr: 'Bar',
    es: 'Bar',
  },
  'services.desc': {
    en: "We don't just show up and pour. We help you plan the perfect beverage experience from start to finish, ensuring you have exactly what you need—no more, no less.",
    fr: "Nous ne nous contentons pas d'arriver et de servir. Nous vous aidons à planifier l'expérience boisson parfaite du début à la fin, en nous assurant que vous ayez exactement ce dont vous avez besoin — ni plus, ni moins.",
    es: 'No solo llegamos y servimos. Te ayudamos a planificar la experiencia de bebidas perfecta de principio a fin, asegurándonos de que tengas exactamente lo que necesitas—ni más, ni menos.',
  },
  'services.s1': {
    en: 'Customized alcohol shopping list',
    fr: "Liste de courses d'alcool personnalisée",
    es: 'Lista de compras de alcohol personalizada',
  },
  'services.s2': {
    en: 'Quantity recommendations based on menu & guest count',
    fr: "Recommandations de quantités basées sur le menu et le nombre d'invités",
    es: 'Recomendaciones de cantidad basadas en el menú y el número de invitados',
  },
  'services.s3': {
    en: 'Beer and wine guidance',
    fr: 'Conseils pour la bière et le vin',
    es: 'Asesoramiento sobre cerveza y vino',
  },
  'services.s4': {
    en: 'Full drink menu planning support',
    fr: 'Assistance complète pour la planification du menu des boissons',
    es: 'Soporte completo para la planificación del menú de bebidas',
  },

  // Call To Action
  'cta.title.part1': {
    en: 'Ready to',
    fr: 'Prêt à',
    es: '¿Listo para',
  },
  'cta.title.part2': {
    en: 'Elevate',
    fr: 'Sublimer',
    es: 'Elevar',
  },
  'cta.title.part3': {
    en: 'Your Next Event?',
    fr: 'Votre Prochain Événement ?',
    es: 'Tu Próximo Evento?',
  },
  'cta.desc': {
    en: 'Let us shake up your celebration with style, ease, and unforgettable cocktails.',
    fr: 'Laissez-nous secouer votre célébration avec style, facilité et des cocktails inoubliables.',
    es: 'Déjanos agitar tu celebración con estilo, facilidad y cócteles inolvidables.',
  },
  'cta.button': {
    en: 'Book Your Event',
    fr: 'Réservez Votre Événement',
    es: 'Reserva Tu Evento',
  },

  // Footer
  'footer.tagline': {
    en: 'Where every event deserves a cheers.',
    fr: 'Où chaque événement mérite un toast.',
    es: 'Donde cada evento merece un brindis.',
  },
  'footer.rights': {
    en: 'Cheers by Lisa. All rights reserved.',
    fr: 'Cheers by Lisa. Tous droits réservés.',
    es: 'Cheers by Lisa. Todos los derechos reservados.',
  },
  'footer.privacy': {
    en: 'Privacy Policy',
    fr: 'Politique de Confidentialité',
    es: 'Política de Privacidad',
  },
  'footer.terms': {
    en: 'Terms of Service',
    fr: "Conditions d'Utilisation",
    es: 'Términos de Servicio',
  },
}
